var indexBrowser = globalThis.fetch;
const { fetch, Response, Request, Headers } = globalThis;

export { Headers, Request, Response, indexBrowser as default, fetch };
